import Emails from "./Emails";

export default Emails;
